var path = 'public/app/plugins/datasource/cloudwatch/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<cloudwatch-query-parameter target=ctrl.target datasource=ctrl.datasource on-change=ctrl.refresh()></cloudwatch-query-parameter>\n</query-editor-row>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/plugins/datasource/cloudwatch/partials/query.editor.html
// module id = 863
// module chunks = 2